import { IApplicationState } from '../../types/redux';

export const promosSeoPageActiveSelector = (state: IApplicationState): boolean => {
  return state.seoPages.isPromosSeoPageActive;
};
